import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { DOMICILIO_FISCAL } from '../../../common/types/tipoEstablecimientoType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';


import establecimientoService from '../../../service/administracion/establecimientoService';
import tipoEstablecimientoService from '../../../service/administracion/tipoEstablecimientoService';
import ubigeoService from '../../../service/integracion/ubigeoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            tipoEstablecimientos: [],
            estados: estadoMock.values,
            filter: {
                nombre: "",
                idTipoEstablecimiento: 0,
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    /********* PAGINATION ********/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            idTipoEstablecimiento: 0,
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            telefono: '',
            codigoSunat: '',
            tipoEstablecimientos: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            flagAmazonia: false,
        }
    }

    handleClearFilters = async () => {
        var filter = {
            nombre: "",
            idTipoEstablecimiento: 0,
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);

    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await establecimientoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Establecimiento.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await establecimientoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Establecimiento.pdf");
    }


    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await establecimientoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await establecimientoService.eliminar(values);
            else
                response = await establecimientoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tipoEstablecimientos = this.state.tipoEstablecimientos.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
        formValues.departamentos = this.state.departamentos;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        const response = await establecimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.tipoEstablecimientos = this.state.tipoEstablecimientos.filter(m => { return m.codigoSunat !== DOMICILIO_FISCAL.CODIGO });
            response.departamentos = this.state.departamentos;
            response.provincias = await ubigeoService.provincias(response.idDepartamento);
            response.distritos = await ubigeoService.distritos(response.idProvincia);
            this.setState({ visible: true, formValues: response });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provincias: provincias ? provincias : [],
                    distritos: []
                }
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritos: distritos ? distritos : []
                }
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.id === 0)
                response = await establecimientoService.registrar(values);
            else
                response = await establecimientoService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, establecimientoService.paginacion);
        const tipoEstablecimientos = await tipoEstablecimientoService.listar();
        const departamentos = await ubigeoService.departamentos();
        this.setState({
            loadingSource: false,
            tipoEstablecimientos: tipoEstablecimientos ? tipoEstablecimientos : [],
            departamentos: departamentos ? departamentos : []
        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Establecimiento"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    tipoEstablecimientos={this.state.tipoEstablecimientos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onChange={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    };
}